import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, FileText, Linkedin, Mic, Compass, Rocket, Sparkles as SparklesIcon, Target } from "lucide-react";
import { MaskedLines } from "@/components/motion";
import { IMAGES } from "@/data/site";

const PILLS = [
  { icon: FileText, label: "Resume Writing" },
  { icon: Linkedin, label: "LinkedIn Optimisation" },
  { icon: Mic, label: "Interview Coaching" },
  { icon: Compass, label: "Career Roadmap" },
  { icon: Rocket, label: "Career Transition Programme" },
  { icon: SparklesIcon, label: "Personal Branding" },
  { icon: Target, label: "Job Search Strategy" },
];

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden bg-[#142A5E] pt-20 pb-6 md:pt-24 md:pb-10"
    >
      {/* soft blobs */}
      <div className="pointer-events-none absolute -top-24 -left-24 h-96 w-96 rounded-full bg-white/5 blur-3xl" />
      <div className="pointer-events-none absolute top-1/3 -right-20 h-80 w-80 rounded-full bg-[#2FA86A]/15 blur-3xl" />

      <div className="nc-container relative grid items-center gap-12 lg:grid-cols-[1.08fr_0.92fr]">
        {/* Left copy */}
        <div>
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 rounded-full border border-[#142A5E]/15 bg-white px-4 py-1.5 text-sm font-medium text-[#142A5E]"
          >
            <SparklesIcon className="h-4 w-4 text-[#2FA86A]" />
            Career Intelligence · Talent Solutions · Business Growth
          </motion.div>

          <h1 className="mt-6 font-display text-3xl leading-[1.1] tracking-tight text-white sm:text-5xl lg:text-[3.4rem] font-extrabold">
            <MaskedLines
              lines={["Careers built with strategy,", <span className="text-[#2FA86A]">Teams built to last.</span>]}
              start={0.1}
            />
          </h1>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.5 }}
            className="mt-7 max-w-xl text-lg leading-relaxed text-white/70"
          >
            Whether you're a professional ready for your next move or an organisation shaping your next chapter — North Cadence brings the intelligence, structure, and access to make it happen.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.6 }}
            className="mt-9 flex flex-col sm:flex-row items-start sm:items-center gap-4"
          >
            {/* <Link
              to="/contact"
              data-testid="hero-book-consultation"
              className="group inline-flex items-center gap-2 rounded-full bg-[#2FA86A] px-7 py-4 text-base font-semibold text-white transition-colors duration-300 hover:bg-[#248a5a]"
            >
              Build My Career
              <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link> */}
            <Link
              to="/services"
              data-testid="hero-explore-services"
              className="group inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-7 py-4 text-base font-semibold text-white transition-colors duration-300 hover:bg-white/20"
            >
              Explore Services
            </Link>
          </motion.div>

          {/* <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.7 }}
            className="mt-9 flex flex-wrap gap-2.5"
          >
            {PILLS.map((p) => (
              <span
                key={p.label}
                className="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/10 px-3.5 py-1.5 text-xs font-medium text-white/80"
              >
                <p.icon className="h-3.5 w-3.5 text-[#2FA86A]" />
                {p.label}
              </span>
            ))}
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.85 }}
            className="mt-5 text-sm text-white/50"
          >
            Also supporting organisations on recruitment, RPO, talent
            acquisition, and business growth
          </motion.p> */}
        </div>

        {/* Right image treatment */}
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <img
            src={IMAGES.team}
            alt="North Cadence team collaboration"
            className="aspect-video w-full object-contain"
            loading="eager"
          />
        </motion.div>
      </div>
    </section>
  );
}
